/**
 * Press Archive — Filter, Search & Pagination
 */

import { initArchiveFilter } from './archive-filter.js';
import { revealStagger, motionTokens } from './motion-primitives.js';

document.addEventListener('DOMContentLoaded', () => {
	initArchiveFilter({
		archiveSelector: '.rmh-press-archive',
		gridSelector: '[data-press-grid]',
		countSelector: '[data-press-count]',
		tabSelector: '.rmh-press-tab',
		paginationButtonSelector: '.rmh-press-page-btn',
		scrollTargetSelector: '.rmh-press-tab',
		searchParam: 'press_search',
		errorContext: 'Press filter error',
		gridWrapperClass: 'grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-2 md:gap-y-[72px] lg:grid-cols-3',
		paginationContainerAttr: 'data-press-pagination',
		defaultStrings: {
			noResults: 'No press entries found.',
			error: 'Something went wrong. Please try again.',
		},
	});

	// Initial-paint stagger across visible press cards.
	const grid = document.querySelector('.rmh-press-archive [data-press-grid] > div');
	if (grid) {
		revealStagger(grid, {
			childSelector: ':scope > *',
			stagger: motionTokens.stagger,
			duration: motionTokens.durMd,
			maxAnimated: 6,
		});
	}
});
